<template>
  
  <nav>
        <jet-responsive-nav-link   :active="route().current('tallyclinic.index')" :href="'/login'" class="item " data-text="Acceuil">
            <i class="fas fa-home"></i>
        </jet-responsive-nav-link >
        <jet-responsive-nav-link   :href="'/comingsoon'" class="item " data-text="Statistiques ">
            <i class="fas fa-chart-line"></i>
        </jet-responsive-nav-link >
        <jet-responsive-nav-link   :active="route().current('integrates.index')"  :href="'/integrates'" class="item" data-text="Messages">
            <i class="fas fa-comments"></i>
        </jet-responsive-nav-link >
        <jet-responsive-nav-link  href="#" class="item" data-text="Profile">
            <i class="fas fa-user-alt"></i>
        </jet-responsive-nav-link >
        <jet-responsive-nav-link  href="#" class="item " data-text="Se connecter">
            <i class="fas fa-sign-in-alt"></i>
        </jet-responsive-nav-link >
    </nav>

      <div class="main-section">
           <slot></slot>
      </div>
  
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
export default {
components:{
JetResponsiveNavLink,
AppLayout,
},

mounted(){

}
}
</script>

<style>
.main-section{
    margin-left: 71px;
}
nav{
    /* padding:0px 12px; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: fixed;
    min-height: 100vh;
    background-color: #f3f4f6;
    text-align: center;
}
nav .item {
    color: white;
    /* font-size: 2rem; */
    text-decoration: none;
    position: relative;
}
nav  i{
    padding : 0.1em;
    font-size: 1.2rem;
}
nav .item:hover i{
    color: blue;
}
nav .item::after{
    content: attr(data-text);
    position: absolute;
    font-size: 13px;
    top: 50%;
    white-space: nowrap;
    padding:6px;
    border-radius: 10px;
    background-color: #e7edef;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, transform 0.0s;
    color: black;
    margin-left: 28px;
}
nav .item:hover::after{
    visibility: visible;
    transform: translate(10px,-50%);
    opacity: 1;
}
.item{
   margin-top: 8px; 
}
</style>